import * as React from 'react'
import { useState } from "react"
import Table from 'react-bootstrap/Table'
import CircularProgress from '@mui/material/CircularProgress';
import './Actuaciones.css';

function Actuaciones(props) {

    const [modal, setModal] = useState('')
    const [span, setSpan] = useState('')
    const [entries, setEntries] = useState([])
    const [displayData, setDisplayData] = useState('')
    const [loaded, setLoaded] = useState(false)

    React.useEffect(() => {
        fetch(`${props.url}/procesos-api/load-entries`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Token '+ localStorage.getItem('token'),
            },
            body: JSON.stringify({
                idProceso: props.idProceso,
            })})
            .then(res => res.json())
            .then(json => setEntries(json.entries))
            .then(setLoaded('true'))
        // Get the modal
        setModal(document.getElementById("detailModal"))

        // Get the <span> element that closes the modal
        setSpan(document.getElementById("closeDetailActuaciones"))

        // When the user clicks anywhere outside of the modal, close it
        window.onclick = function(event) {
        if (event.target === modal) {
            modal.style.display = "none";
            }
        }
        // When the user clicks on <span> (x), close the modal
        try {span.onclick = function() {
            modal.style.display = "none";
        }} catch {}
    }, [modal, span, props.idProceso, props.url])

    // Display modal with each entry info
    const openEntry = async function(event) {
        const tag = event.target.tagName;
        if (tag === "SPAN") {
            console.log(event.target.tagName)
            console.log(event.target.parentNode.tagName)
            const index = event.target.parentNode.parentNode.id;
            const idDocumento = await fetch(`https://consultaprocesos.ramajudicial.gov.co:448/api/v2/Proceso/DocumentosActuacion/${entries[index].radicado}`).then(res => res.json()).then(json => json[0].idRegDocumento)
            try {
                await fetch(`https://consultaprocesos.ramajudicial.gov.co:448/api/v2/Descarga/Documento/${idDocumento}`).then( res => res.blob() ).then( blob => {
                    var file = window.URL.createObjectURL(blob);
                    window.location.assign(file);
                })
            } catch {
                console.log('Error descargando')
            }
            return
        }
        if (tag === "A") {
            return
        }
        const index = event.target.parentNode.id;
        setDisplayData(entries[index])
        modal.style.display = "block"
    }

    return (<React.Fragment>
        {
        loaded ? 
        <React.Fragment>
            <div className="actuacionesTable">
                <Table striped bordered hover>
                    <tbody>
                        <tr>
                            <td className="highlight">Fecha</td>
                            <td className="highlight">Actuacion</td>
                        </tr>
                        {entries.map((entry) => {
                            return(
                                <tr key={entries.indexOf(entry)}
                                    onClick={(event) => openEntry(event)}
                                    id={entries.indexOf(entry)}>
                                    <td>{entry.fecha}</td>
                                    <td>{entry.actuacion}
                                    {
                                        entry.documento 
                                        ? <span className="material-icons-round download">download</span> 
                                        : entry.link 
                                        ? <a href={entry.link} target="_blank" rel="noreferrer noopener" className="material-icons-round download">link</a> : null}
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>     
            </div>

            <div id="detailModal" className="modal-proceso">
                <div className="modal-content-proceso">
                    <div id="closeDetailActuaciones">&times;</div>

                    <Table className="detail-table-s" striped bordered hover>
                        <tbody>
                            <tr>
                                <td className="highlight">Fecha</td>
                                <td>{displayData.fecha}</td>
                            </tr>
                            <tr>
                                <td className="highlight">Tipo de actuacion</td>
                                <td>{displayData.actuacion}</td>
                            </tr>
                            <tr>
                                <td className="highlight">Termino inicia</td>
                                <td>{displayData.desde}</td>
                            </tr>
                            <tr>
                                <td className="highlight">Termino acaba</td>
                                <td>{displayData.hasta}</td>
                            </tr>
                            <tr>
                                <td className="highlight" colSpan="4">Detalles</td>
                            </tr>
                            <tr>
                                <td colSpan="2">{displayData.anotacion}</td>
                            </tr>
                        </tbody>
                    </Table>

                    <Table className="detail-table-l" striped bordered hover>
                        <tbody>
                            <tr>
                                <td className="highlight">Fecha</td>
                                <td>{displayData.fecha}</td>
                                <td className="highlight">Tipo de actuacion</td>
                                <td>{displayData.actuacion}</td>
                            </tr>
                            <tr>
                                <td className="highlight">Registro</td>
                                <td>{displayData.desde}</td>
                                <td className="highlight">Termino acaba</td>
                                <td>{displayData.hasta}</td>
                            </tr>
                            <tr>
                                <td className="highlight" colSpan="4">Detalles</td>
                            </tr>
                            <tr>
                                <td colSpan="4">{displayData.anotacion !== "" ? displayData.anotacion : "Sin detalles"}</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            </div>
        </React.Fragment>
        :  
        <div>
                <div className='loading'><CircularProgress /></div>
                <div className='text-misProcesos'>Revisando los expedientes ...</div>
        </div>
        }
        </React.Fragment> 
    );
}

export { Actuaciones };
